exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Icono de estrella para Mis Destacados */\n.SideMenu-starIcon-2EJD9 {\n  -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n  margin-right: 6px !important;\n  vertical-align: middle !important;\n}\n", ""]);

// exports
exports.locals = {
	"starIcon": "SideMenu-starIcon-2EJD9"
};